
// export default router
import Vue from 'vue'
import VueRouter from 'vue-router'
// import HomeView from '../views/HomeView.vue'
import Layout from "../views/layout/layout.vue";
Vue.use(VueRouter)
export const constantRoutes = [{
	path: "/redirect",
	component: Layout,
	hidden: true,
	children: [{
		path: "/redirect/:path(.*)",
		component: () => import("../views/redirect/index")
	}]
},
{
	path: "/",
	component: () => import("../views/homepage.vue"),
	hidden: true
},
{
	path: "/login",
	component: () => import("../views/login/login.vue"),
	hidden: true
},
{
	path: "/auth-redirect",
	component: () => import("../views/login/authredirect"),
	hidden: true
},
{
	path: '/register',
	name: 'register',
	component: () => import('../views/Register.vue')
},
{
	path: '/home',
	component: Layout,
	redirect: '/home/list',
	hidden: false,
	meta: {
		title: '企业填报',
		affix: true
	},
	children: [
		{
			path: '/home/list',
			component: () => import("../views/home/List.vue"),
			name: 'list',
			// hidden: true,
			meta: {
				title: '企业填报',
				affix: true
			},
		},
	]
}, {
	path: '/apply',
	component: Layout,
	redirect: '/apply/apply',
	hidden: false,
	meta: {
		title: '申请记录',
		// icon: require('@/assets/image/1.png'),
		// active_icon: require('@/assets/image/11.png'),
		affix: true
	},
	children: [
		{
			path: '/apply/apply',
			component: () => import("../views/apply.vue"),
			name: 'apply',
			// hidden: true,
			meta: {
				title: '申请记录',
				affix: true
			},
		},
	]
},
{
	path: '/filling',
	component: Layout,
	redirect: '/filling/filling',
	hidden: true,
	meta: {
		title: '企业填报',
		// icon: require('@/assets/image/1.png'),
		// active_icon: require('@/assets/image/11.png'),
		affix: true
	},
	children: [
		{
			path: '/filling/filling',
			component: () => import("../views/home/fillcontent.vue"),
			name: 'list',
			meta: {
				title: '企业填报',
				affix: true
			}
		},
	]
},
];

export const asyncRoutes = [
	{
		path: '/system',
		component: Layout,
		redirect: '/system/users',
		meta: {
			title: "系统管理",
			icon: ""
		},
		children: [
			{
				path: 'users',
				component: () => import('@/views/system/users.vue'),
				name: 'users',
				meta: { title: '用户管理', icon: '', affix: true, perms: ['user:add', 'user:delete', 'user:update', 'user:disable', 'user:list', 'user:bind:role'] }
			}, {
				path: 'roles',
				component: () => import('@/views/system/roles.vue'),
				name: 'roles',
				meta: { title: '角色管理', icon: '', affix: true, perms: ['role:add', 'role:delete', 'role:update', 'role:list', 'role:bind:permission'] }
			}, 
			// {
			// 	path: '/permission',
			// 	component: () => import('@/views/system/permList.vue'),
			// 	name: 'permission',
			// 	meta: { title: '权限管理', icon: '', affix: true, perms: ['permission:add', 'permission:delete', 'permission:update', 'permission:list'] }
			// },
			 {
				path: 'logpage',
				component: () => import('@/views/system/logpage.vue'),
				name: 'logpage',
				meta: { title: '日志管理', icon: '', affix: true, perms: ["log:delete", "log:list", "log:export"] }
			},
		]
	}, {
		path: '/statistics',
		component: Layout,
		redirect: '/statistics/statistics',
		hidden: false,
		meta: {
			title: '统计分析',
			// icon: require('@/assets/image/1.png'),
			// active_icon: require('@/assets/image/11.png'),
			affix: true
		},
		children: [
			{
				path: '/statistics/statistics',
				component: () => import("../views/statistics.vue"),
				name: 'statistics',
				// hidden: true,
				meta: {
					title: '统计分析',
					affix: true,
					perms: ["statistics:month"]
				},
			},
		]
	}
];
const createRouter = () =>
	new VueRouter({
		mode: 'history',
		base: '/bj-smart-fill',
		routes: constantRoutes
	});
const router = createRouter();

export function resetRouter() {
	const newRouter = createRouter();
	router.matcher = newRouter.matcher; // reset router
}
export default router;

// import Router from 'vue-router'
const routerPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
	return routerPush.call(this, location).catch(error => error);
};